/** Card skin visual styles for flashcard components */
export function getCardSkinStyles(equippedCardSkin: string): Record<string, string> {
  switch (equippedCardSkin) {
    case "fireBorder":
      return {
        border: "2px solid rgb(249 115 22)",
        boxShadow: "0 0 15px rgba(255, 165, 0, 0.7)",
      };
    case "holographicBorder":
      return {
        border: "2px solid rgba(168, 85, 247, 0.6)",
        boxShadow: "0 0 20px rgba(168, 85, 247, 0.5), 0 0 40px rgba(99, 102, 241, 0.3)",
      };
    case "pixelBorder":
      return {
        border: "3px solid hsl(var(--foreground))",
        boxShadow: "4px 4px 0 hsl(var(--foreground))",
      };
    case "spaceBorder":
      return {
        border: "1px solid rgb(56 189 248)",
        boxShadow: "0 0 20px rgba(56, 189, 248, 0.6)",
      };
    default:
      return {};
  }
}
